module.exports = __webpack_public_path__ + "static/media/love.bafd0b41.svg";